import { render, staticRenderFns } from "./new1.vue?vue&type=template&id=2494eb17&scoped=true&"
import script from "./new1.vue?vue&type=script&lang=js&"
export * from "./new1.vue?vue&type=script&lang=js&"
import style0 from "./new1.vue?vue&type=style&index=0&id=2494eb17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2494eb17",
  null
  
)

export default component.exports